import { RESOURCES_BASE_API } from "@/lib/utils/constants";
import getConfig from "next/config";
import Head from "next/head";
const { publicRuntimeConfig } = getConfig();
const { FB_PIXEL_ID, FB_PIXEL_VERIFICATION_CODE } = publicRuntimeConfig;

const CustomHead = () => (
	<Head>
		<title>SALT - Money Personality Test</title>
		<meta name="description" content="SALT" />
		<link
			rel="icon"
			href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
		/>

		<meta
			property="og:title"
			content="Find out which money personality you are!"
		/>
		<meta
			name="twitter:title"
			content="Find out which money personality you are!"
		/>

		<meta name="description" content="Sorted or anxious or cautious?" />
		<meta property="og:description" content="Sorted or anxious or cautious?" />
		<meta name="twitter:description" content="Sorted or anxious or cautious?" />

		<link
			rel="icon"
			sizes="50x50"
			type="image/x-icon"
			href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
		/>
		<link
			rel="shortcut icon"
			href={RESOURCES_BASE_API + "/common/meta/favicon50x50.ico"}
			type="image/x-icon"
		/>
		<link
			rel="apple-touch-icon"
			href={
				RESOURCES_BASE_API +
				"/psychometric/meta/thumbnail-money-personality-test.png"
			}
			type="image/jpeg"
		/>

		<link
			rel="mask-icon"
			href={
				RESOURCES_BASE_API +
				"/psychometric/meta/thumbnail-money-personality-test.png"
			}
		/>

		<meta
			property="og:image"
			itemProp="image"
			content={
				RESOURCES_BASE_API +
				"/psychometric/meta/thumbnail-money-personality-test.png"
			}
		/>
		<meta property="og:url" content="https://app.salt.one/personality" />
		<meta property="og:site_name" content="SALT" />
		<meta property="og:type" content="website" />

		<meta name="twitter:card" content="summary" />
		<meta name="twitter:site" content="@mysaltapp" />
		<meta
			name="twitter:image"
			content={
				RESOURCES_BASE_API +
				"/psychometric/meta/thumbnail-money-personality-test.png"
			}
		/>
		<meta
			name="twitter:image:alt"
			content="Find out which money personality you are!"
		/>
		<meta
			name="facebook-domain-verification"
			content={FB_PIXEL_VERIFICATION_CODE}
		/>
		<script
			dangerouslySetInnerHTML={{
				__html: `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${FB_PIXEL_ID}');
fbq('track', 'PageView');
`,
			}}
		></script>
		<noscript>
			<img
				alt="fb"
				height="1"
				width="1"
				style={{ display: "none" }}
				src="https://www.facebook.com/tr?id=2904984216467136&ev=PageView&noscript=1"
			/>
		</noscript>
	</Head>
);

export default CustomHead;
